if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.sectionId = this.dataset.sectionId;
				this.form = this.querySelector("form");
				this.form.querySelector("[name=id]").disabled = false;
				this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
				this.cart = document.querySelector("cart-drawer");
				this.submitButton = this.querySelector('[type="submit"]');

				this.cardVariantsSelect = this.querySelector(
					".select__select.product__card--variants"
				);
				if (this.cardVariantsSelect) {
					this.cardVariantsSelect.addEventListener("change", ({ target }) => {
						this.querySelector(".product__card--id").value = target.value;
						this.updateCardProductPrice(target.value);
						this.updateCardImage(target.value);
					});
				}

				if (this.sectionId) {
					this.addons = document.querySelectorAll(`.addon-${this.sectionId}`);
					this.addons && this.handleAddonsSelection();

					this.packs = document.querySelectorAll(`.pack-${this.sectionId}`);
					this.packs && this.handlePacksSelection();

					this.customVariants = document.querySelectorAll(
						`.custom-variant-${this.sectionId}`
					);
				}

				if (document.querySelector("cart-drawer"))
					this.submitButton.setAttribute("aria-haspopup", "dialog");

				this.hideErrors = this.dataset.hideErrors === "true";
			}

			onSubmitHandler(evt) {
				evt.preventDefault();
				if (
					this.submitButton.getAttribute("aria-disabled") === "true" ||
					currency !== "inherit"
				)
					return;

				this.handleErrorMessage();

				this.submitButton.setAttribute("aria-disabled", true);
				this.submitButton.classList.add("loading");
				this.querySelector(".loading__spinner").classList.remove("hidden");

				const formData = new FormData();
				const productId = this.form.querySelector('[name="id"]').value;

				const properties = {};
				let requiredEmptyProperties = false;
				if (this.customVariants) {
					this.customVariants.forEach((input) => {
						const isFileInput = input.type === "file";
						const isEmpty = isFileInput
							? input.files.length === 0
							: !input.value;

						if (input.required && isEmpty) {
							requiredEmptyProperties = true;
							input.closest(".field").classList.add("error");
							this.submitButton.setAttribute("aria-disabled", false);
							this.submitButton.classList.remove("loading");
							this.querySelector(".loading__spinner").classList.add("hidden");
						} else {
							input.closest(".field").classList.remove("error");
						}

						if (input.name.startsWith("properties[")) {
							const propertyName = input.name.replace(
								/^properties\[(.*)\]$/,
								"$1"
							);

							if (isFileInput && input.files.length > 0) {
								properties[propertyName] = input.files[0];
							} else if (!isFileInput && input.value) {
								properties[propertyName] = input.value;
							}
						}
					});
				}
				if (requiredEmptyProperties) return;

				let itemIndex = 1,
					productQty =
						document.querySelector(`#Quantity-${this.sectionId}`)?.value || 1;
				if (this.addons) {
					this.addons.forEach((addon) => {
						if (!addon.classList.contains("active")) return;
						const variantId = addon.dataset.variant;
						if (variantId) {
							formData.append(`items[${itemIndex}][id]`, variantId);
							formData.append(`items[${itemIndex}][quantity]`, 1);
							itemIndex++;
						}
					});
				}

				if (this.packs) {
					this.packs.forEach((pack) => {
						if (!pack.classList.contains("active")) return;

						const variants = pack.dataset.variant?.split(",");
						if (variants) {
							variants.forEach((variant) => {
								formData.append(`items[${itemIndex}][id]`, variant);
								formData.append(`items[${itemIndex}][quantity]`, 1);
								itemIndex++;
							});
						}

						productQty = pack.dataset.bundleQuantity;
					});
				}

				if (productId) {
					formData.append("items[0][id]", productId);
					formData.append("items[0][quantity]", productQty);
					let propertyIndex = 0;
					for (const [key, value] of Object.entries(properties)) {
						if (value instanceof File) {
							formData.append(
								`items[0][properties][${key}]`,
								value,
								value.name
							);
						} else {
							formData.append(`items[0][properties][${key}]`, value);
						}
						propertyIndex++;
					}
				}

				formData.append(
					"sections",
					this.cart?.getSectionsToRender()?.map((section) => section.id)
				);
				formData.append("sections_url", window.location.pathname);

				fetch(`${routes.cart_add_url}`, {
					method: "POST",
					headers: {
						"X-Requested-With": "XMLHttpRequest",
						Accept: "application/json",
					},
					body: formData,
				})
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							publish(PUB_SUB_EVENTS.cartError, {
								source: "product-form",
								productVariantId: productId,
								errors: response.errors || response.description,
								message: response.message,
							});
							this.handleErrorMessage(response.description);

							const soldOutMessage =
								this.submitButton.querySelector(".sold-out-message");
							if (!soldOutMessage) return;
							this.submitButton.setAttribute("aria-disabled", true);
							this.submitButton.querySelector("span").classList.add("hidden");
							soldOutMessage.classList.remove("hidden");
							this.error = true;
							return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						if (!this.error)
							publish(PUB_SUB_EVENTS.cartUpdate, {
								source: "product-form",
								productVariantId: productId,
								cartData: response,
							});

						this.error = false;
						this.cart.renderContents(response);
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove("loading");
						if (this.cart && this.cart.classList.contains("is-empty"))
							this.cart.classList.remove("is-empty");
						if (!this.error) this.submitButton.removeAttribute("aria-disabled");
						this.querySelector(".loading__spinner").classList.add("hidden");
					});
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;

				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						".product-form__error-message"
					);

				this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}

			handleAddonsSelection() {
				if (!this.addons) return;
				this.addons.forEach((addon) => {
					addon.addEventListener("click", () => {
						addon.classList.toggle("active");
					});
				});
			}

			handlePacksSelection() {
				if (!this.packs) return;
				this.packs[0]?.classList.add("active");
				this.packs.forEach((pack) => {
					pack.addEventListener("click", () => {
						this.packs.forEach((el) => el.classList.remove("active"));
						pack.classList.add("active");
						this.updatePrice(pack.dataset.price);
					});
				});
			}

			updatePrice(price) {
				const submitPriceDestination = document.getElementById(
					`submit-price-${this.sectionId}`
				);

				if (submitPriceDestination) submitPriceDestination.textContent = price;
			}

			updateCardImage(targetId) {
				const productContainer = this.closest(".product__card");
				const mediaContainer = productContainer?.querySelector(".media");
				const jsonNode = this.querySelector('script[type="application/json"]');
				if (!mediaContainer || !jsonNode) return;

				let variantsData;
				try {
					variantsData = JSON.parse(jsonNode.textContent.trim());
				} catch {
					return;
				}

				const variantData = variantsData?.[String(targetId)];
				if (!variantData || !variantData.image) return;

				const img = document.createElement("img");
				img.src = variantData.image.src;
				if (variantData.image.alt) img.alt = variantData.image.alt;
				if (variantData.image.srcset) img.srcset = variantData.image.srcset;
				if (variantData.image.sizes) img.sizes = variantData.image.sizes;
				if (variantData.image.width) img.width = variantData.image.width;
				if (variantData.image.height) img.height = variantData.image.height;
				if (variantData.image.class) img.className = variantData.image.class;
				mediaContainer.replaceChildren(img);
			}

			updateCardProductPrice(targetId) {
				const productContainer = this.closest(".product__card");
				const regularPrice = productContainer.querySelector(
					".price__regular--amount"
				);
				const comparePrice = productContainer.querySelector(
					".price__compare--amount"
				);

				const variantsData = JSON.parse(
					this.querySelector('[type="application/json"]').textContent
				);
				const variant = variantsData[targetId];

				if (regularPrice && comparePrice && variant) {
					regularPrice.textContent = variant.price;

					if (variant.sale === "true") {
						comparePrice.classList.remove("hidden");
						comparePrice.textContent = variant.compareAtPrice;
					} else {
						comparePrice.classList.add("hidden");
						comparePrice.textContent = "";
					}
				}
			}
		}
	);
}
